export interface SearchRequest {
    terms: Terms
}

export interface SearchResponse {
    results: SearchResult[]
}

export interface SearchResult {
    consultUuid: string
    kind: string
    score: number
}

export interface IndexRequest {
    consultUUID: string
    terms: Terms
}

export type Terms = Term[]
export interface Term {
    kind?: string
    value: string
}


export enum IndexKind {
    consultUuid,
    consultShortid,
    firstName,
    lastName,
    healthId,
    dob,
}
